import {h, Fragment} from 'preact';
import {useState} from 'preact/hooks';
import "./style.css";
import {OnRecord, OnEdit, OnStart, Settings} from "./components";
import Core from "./core";


const Wrapper = ({core}) => {
    const [currentView, setView] = useState('OnStart');
    core.currentView = currentView
    core.setView = setView
    return (
        <Fragment>
            {currentView === 'OnStart' ? <OnStart core={core}/> : null}
            {currentView === 'OnRecord' ? <OnRecord core={core}/> : null}
            {currentView === 'OnEdit' ? <OnEdit core={core}/> : null}
            {/*{currentView === 'Settings' ? <Settings core={core}/> : null}*/}
        </Fragment>
    );
}

export default function App(props) {
    const core = new Core()
    return (
        <div className="on-audio">
            <Wrapper core={core}/>
        </div>
    );
}
